import { i18nFilter } from "app/filters/i18nFilter";
import { minVisitsAbbrFilter, numberFilter, percentageFilter, suffixFilter } from "app/filters/ngFilters";
import { CommonTableOverview } from "app/pages/website-analysis/traffic-sources/display-ads/publishers/common/PublishersOverview";

export const AdvertisersOverview = ({ totalVisits, totalShare, totalUnGroupedCount }: any) => {
    const i18n = i18nFilter();
    const items = [
        {
            value: minVisitsAbbrFilter()(totalVisits),
            text: i18n("analysis.publishers.advertisers.overview.outgoing.ads"),
        },
        {
            value: suffixFilter()(percentageFilter()(totalShare, 2), "%"),
            text: `${i18n("shared.totals.total")} ${i18n(
                "analysis.publishers.advertisers.overview.outgoing.ads.percentage",
            )}`,
        },
        {
            value: numberFilter()(totalUnGroupedCount),
            text: i18n("analysis.publishers.advertisers.overview.count"),
        },
    ];
    return <CommonTableOverview items={items} />;
};
